<script setup lang="ts">
const device = useDevice();

const props = defineProps<{
    title: string,
    desc: string,
    items: Array<{
        title: string,
        img: string,
        groups: {
            title: string,
            desc: string,
        }[]
    }>
}>();
</script>

<template>
    <SectionsBase id="features" class="relative container">
        <ChipsDivider>ویژگی‌ها</ChipsDivider>
        <h2>{{ props.title }}</h2>
        <p class="text-body1-semibold text-gray-400 text-center my-6">{{ props.desc }}</p>
        <ClientOnly>
            <LazySectionsFeaturesWebchatMobile 
                v-if="!device.isDesktop.value" 
                :items
            />
            <LazySectionsFeaturesWebchatDesktop 
                v-else
                :items
            />
        </ClientOnly>
    </SectionsBase>
</template>
